import React from 'react';
import { Image } from '@bottomless/common/components';

export const Ag1ScaleImage = () => (
  <Image src="/connect-scale/ag1/smart-canister-small.png" alt="Bottomless Scale" width="50" useSrcset />
);
